import React from "react";
import "./About.css";
import Me from "../../assets/me-about3.png";
import { AboutCard } from "../common";
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";

const About = () => {
  const { t } = useTranslation();
  return (
    <section id="about">
      <h5 className={i18n.language == "ar" && "arabicText"}>
        {t("aboutSection.get_toknow")}
      </h5>
      <h2 className={i18n.language == "ar" && "arabicText"}>
        {t("aboutSection.about_me-title")}
      </h2>
      <div className="container about_container">
        <div
          className="about_me"
          data-aos="fade-right"
          data-aos-duration="1500"
        >
          <div className="about_me-image">
            <img src={Me} alt="Me " />
          </div>
        </div>
        <div className="about_content">
          <div className="about_cards">
            <AboutCard
              title={t("aboutSection.experience_title")}
              details={t("aboutSection.experience_details")}
              cardClass={"about_card"}
              icon={"FaAward"}
              iconClass={"about_icon"}
              dataAos="fade-up"
            />
            <AboutCard
              title={t("aboutSection.freelencer_title")}
              details={t("aboutSection.freelencer_details")}
              cardClass={"about_card"}
              icon={"VscFolderLibrary"}
              iconClass={"about_icon"}
              dataAos="fade-up"
            />
            <AboutCard
              title={t("aboutSection.trainer_title")}
              details={t("aboutSection.trainer_details")}
              cardClass={"about_card"}
              icon={"FiUsers"}
              iconClass={"about_icon"}
              dataAos="fade-up"
            />
          </div>
          <p
            data-aos="fade-up"
            data-aos-duration="1500"
            className={i18n.language == "ar" && "arabicText rtlText"}
          >
            {t("aboutSection.about_me-desc")}
          </p>
          <a
            href="#contact"
            className={i18n.language=="en"?"btn btn-primary":"btn btn-primary arabicText"}
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            {t("letsTalk-btn")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
